const embedStyles = () => {
  if (typeof document === 'undefined') {
    return
  }
  const emotionBundle = [
    ...document.querySelectorAll<HTMLStyleElement>('[data-emotion]'),
  ]
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    .flatMap(({ sheet }) => [...sheet!.cssRules].map((rules) => rules.cssText))
    .join('\n')

  const style = document.createElement('style')
  style.appendChild(document.createTextNode(emotionBundle))

  document.head.appendChild(style)
}

export default embedStyles
